module.exports = __webpack_public_path__ + "img/front-teeth.50d44676.png";